var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('aside-menu'),_c('top-menu'),_c('v-content',{staticStyle:{"margin":"50px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }